

const initialState = {
  googleDriveError: false,
  uploadStatus: null, // queued|processing|uploaded|failed
  uploadJobId: null,
  uploadError: null,
  youtubeUrl: null,
  platform: null, // New: to store the platform of the current upload
};

export const googleDrive = {
  namespaced: true,
  state: initialState,
  actions: {
    setGoogleDriveError({ commit }, status) {
      commit('setGoogleDriveError', status);
    },
    setUploadStatus({ commit }, status) {
      commit('setUploadStatus', status);
    },
    setUploadError({ commit }, error) {
      commit('setUploadError', error);
    },
    async cancelUpload({ commit, state }) {
      if (state.uploadJobId) {
        try {
          // You might want to call a backend endpoint to cancel the job if supported
          // await axios.post(`/media-upload/cancel/${state.uploadJobId}`);
        } catch (e) {
          console.error('Failed to cancel upload on backend', e);
        }
      }
      commit('setUploadStatus', 'failed');
      commit('setUploadError', 'تم الإلغاء.');
    },
  },
  mutations: {
    setGoogleDriveError(state, status) {
      state.googleDriveError = status;
    },
    setUploadStatus(state, status) {
      state.uploadStatus = status;
    },
    setUploadJobId(state, jobId) {
      state.uploadJobId = jobId;
    },
    setUploadError(state, error) {
      state.uploadError = error;
    },
    setYoutubeUrl(state, url) {
      state.youtubeUrl = url;
    },
    setPlatform(state, platform) {
      state.platform = platform;
    },
  },
};